import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { labelActions } from '@common-reducers/labels-reducer';
import { Loader2 } from 'lucide-react';
import LabelForm from '../label-input-with-emoji-picker';
import { updateLabelThunk } from '@common-reducers/labels-reducer/labels-thunks/crud';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog"
import { useTranslation } from 'react-i18next';
import { namespace } from "@common-config/constants";


export default function EditLabelModalModal() {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch()
    const label = useAppSelector((state) => state.LabelReducer.label)
    const isLabelEditing = useAppSelector((state) => state.LabelReducer.isLabelEditing)
    const labelNetWorkStatus = useAppSelector((state) => state.LabelReducer.labelNetWorkStatus)

    const handleOpenChange = (open: boolean) => {
        dispatch(labelActions.toggleEditLabel(open))
        if (!open) {
            dispatch(labelActions.setLabel({}))
        }
    }

    return (
        <Dialog open={isLabelEditing} onOpenChange={handleOpenChange}>
            <DialogContent className="sm:max-w-md p-0 gap-0 overflow-hidden bg-white">
                <DialogHeader className="px-6 py-4 border-b border-zinc-100">
                    <DialogTitle className="text-lg font-semibold text-zinc-900">{t('labels.editCustomLabel')}</DialogTitle>
                </DialogHeader>

                <div className="px-6 py-4">
                    <LabelForm />
                </div>

                <div className="px-6 pb-6">
                    <Button
                        onClick={() => dispatch(updateLabelThunk())}
                        disabled={!label.name || labelNetWorkStatus === 'update-label'}
                        className="w-full gap-2 h-10 rounded-md font-medium bg-blue-600 hover:bg-blue-700 text-white disabled:bg-gray-200 disabled:text-gray-400"
                    >
                        {labelNetWorkStatus === 'update-label' ? (
                            <>
                                <Loader2 size={16} className="animate-spin" />
                                {t('labels.updating')}
                            </>
                        ) : (
                            t('common.save')
                        )}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}